import * as React from 'react';
import { LinkButton, UIText2 } from '@cian/ui-kit';
import { Attention16 } from '@cian/ui-kit/prev';
import * as styles from './PndBanner.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var PndBanner = function PndBanner(_ref) {
  var url = _ref.url,
    onLinkClick = _ref.onLinkClick;
  return /*#__PURE__*/_jsxs("div", {
    className: styles['container'],
    children: [/*#__PURE__*/_jsx("div", {
      className: styles['icon'],
      children: /*#__PURE__*/_jsx(Attention16, {
        color: "primary_100"
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: styles['description'],
      children: [/*#__PURE__*/_jsx(UIText2, {
        children: "\u0423\u0434\u0430\u043B\u044F\u0442\u044C \u0434\u0443\u0431\u043B\u0438 \u043C\u043E\u0436\u043D\u043E \u043F\u0440\u044F\u043C\u043E \u0432 \u043B\u0438\u0447\u043D\u043E\u043C \u043A\u0430\u0431\u0438\u043D\u0435\u0442\u0435 \u2014 \u0442\u0430\u043A\u0430\u044F \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u044C \u0435\u0441\u0442\u044C \u0442\u043E\u043B\u044C\u043A\u043E \u0443 \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u0438\u043A\u043E\u0432 \u043E\u0431\u044A\u0435\u043A\u0442\u0430"
      }), /*#__PURE__*/_jsx("div", {
        className: styles['action'],
        children: /*#__PURE__*/_jsx(LinkButton, {
          href: url,
          target: "_self",
          theme: "fill_primary",
          size: "XS",
          onClick: onLinkClick,
          children: "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u0432 \u043B\u0438\u0447\u043D\u044B\u0439 \u043A\u0430\u0431\u0438\u043D\u0435\u0442"
        })
      })]
    })]
  });
};